<template>
	<v-card class="selected-content-card">
		<v-img :src="coverImageUrl" aspect-ratio="1.9"></v-img>
        <v-card-title primary-title>
			<h3 class="subheading mb-0" v-html="content.title" v-line-clamp="2"></h3>
        </v-card-title>
        <v-btn v-if="allowRemove" fab small icon class="remove-content-button" dark color="black" @click="handleRemove($event)">
        	<v-icon>close</v-icon>
        </v-btn>
        <v-card-actions v-if="hasFooter">
        	<slot name="footer"></slot>
        </v-card-actions>
	</v-card>
</template>

<script>
	import * as config from '@/config'

	export default {
		props: {
			content: {
				type: Object,
				default: null
			},
			allowRemove: {
				type: Boolean,
				default: true
			}
		},
		computed: {
			coverImageUrl () {
				if (!this.content) return null
				return (this.content.coverUrl.substring(0, 4) != 'http') ? 'https://www.jeban.com/' + ('/' + this.content.coverUrl).replace('//', '/') : this.content.coverUrl
			},
			hasFooter () {
				return (typeof this.$slots.footer !== 'undefined')
			}
		},
		methods: {
			handleRemove (event) 
			{
				this.$emit('on-remove', event)
			}
		},
		mounted () {

		}
	}
</script>

<style lang="scss">
	.selected-content-card {
		position: relative;

		.remove-content-button {
			position: absolute;
			right: 0;
			top: 0;
			height: 24px;
			width: 24px;
			transform: translate(75%, -50%);
		}
	}
</style>